<template>
    <div class="pages">
        <!--顶部统计-->
        <div class="statistics-number">
            <div class="statistics-item">
                <div class="title">
                    <span>销售金额</span>
                    <div class="tag">
                        <span>今日</span>
                    </div>
                </div>
                <div class="number">
                    <span>{{ data.todaySales }}</span>
                </div>
                <div class="details">
                    <span>昨日 {{ data.lastdaySales }}</span>
                </div>
                <div class="total">
                    <span>本月销售额</span>
                    <span>{{ data.currentMonthSales }}</span>
                </div>
            </div>
            <div class="statistics-item">
                <div class="title">
                    <span>销售数量</span>
                    <div class="tag">
                        <span>今日</span>
                    </div>
                </div>
                <div class="number">
                    <span>{{ data.todaySalesNumber }}</span>
                </div>
                <div class="details">
                    <span>昨日 {{ data.lastdaySalesNumber }}</span>
                </div>
                <div class="total">
                    <span>本月销售数量</span>
                    <span>{{ data.currentMonthSalesNumber }}</span>
                </div>
            </div>
            <div class="statistics-item">
                <div class="title">
                    <span>用户新增/有效用户新增</span>
                    <div class="tag">
                        <span>今日</span>
                    </div>
                </div>
                <div class="number">
                    <span>{{ data.todayUserAdd }}/{{data.todayValidUserAdd}}</span>
                </div>
                <div class="details">
                    <span>昨日 {{ data.lastdayUserAdd }}/{{data.lastdayValidUserAdd}}</span>
                </div>
                <div class="total">
                    <span>本月用户新增/本月有效用户新增</span>
                    <span>{{ data.currentMonthUserAdd }}/{{data.currentMonthValidUserAdd}}</span>
                </div>
            </div>
            <div class="statistics-item">
                <div class="title">
                    <span>访问数量/访客数量</span>
                    <div class="tag">
                        <span>今日</span>
                    </div>
                </div>
                <div class="number">
                    <span>{{ data.todayVisitNumber }}/{{data.todayVisitorNumber}}</span>
                </div>
                <div class="details">
                    <span>昨日 {{ data.lastdayVisitNumber }}/{{data.lastdayVisitorNumber}}</span>
                </div>
                <div class="total">
                    <span>本月访问数量/本月访客数量</span>
                    <span>{{ data.currentMonthVisitNumber }}/{{data.currentMonthVisitorNumber}}</span>
                </div>
            </div>
        </div>

        <!--快捷菜单-->
        <div class="shortcut-menu">
            <div class="menu-item" @click="onSkip('/shop/OrderList')">
                <div class="icon-box">
                    <i class="iconfont ooicon-order-fill" style="color: #0256ff"></i>
                </div>
                <span>订单管理</span>
            </div>

            <div class="menu-item" @click="onSkip('/shop/ProductList')">
                <div class="icon-box">
                    <i class="iconfont ooicon-product-fill" style="color: #0fc6c2"></i>
                </div>
                <span>商品管理</span>
            </div>

            <div class="menu-item" @click="onSkip('/finance/MoneyRecordList')">
                <div class="icon-box">
                    <i class="iconfont ooicon-money-rmb-fill" style="color: #ff7d00"></i>
                </div>
                <span>资金明细</span>
            </div>

            <div class="menu-item" @click="onSkip('/finance/MoneyFlowList')">
                <div class="icon-box">
                    <i class="iconfont ooicon-money-inquiry-template-fill" style="color: #7da2ff"></i>
                </div>
                <span>资金流水</span>
            </div>

            <div class="menu-item" @click="onSkip('/user/UserList')">
                <div class="icon-box">
                    <i class="iconfont ooicon-customer-fill" style="color: #f7ba1e"></i>
                </div>
                <span>用户管理</span>
            </div>

            <div class="menu-item" @click="onSkip('/finance/UserMoneyList')">
                <div class="icon-box">
                    <i class="iconfont ooicon-money-wallet-fill" style="color: #b37feb"></i>
                </div>
                <span>用户资产</span>
            </div>

            <div class="menu-item" @click="onSkip('/article/articleList')">
                <div class="icon-box">
                    <i class="iconfont ooicon-template-fill" style="color: #0fc6c2"></i>
                </div>
                <span>文章管理</span>
            </div>

            <div class="menu-item" @click="onSkip('/config/SysConfig')">
                <div class="icon-box">
                    <i class="iconfont ooicon-settings-fill" style="color: #9fdb1d"></i>
                </div>
                <span>系统配置</span>
            </div>
        </div>

        <!--统计图表-->
        <div class="diagram">
            <div class="time-button">
                <div class="item-btn" :class="{'active': chart1 === 1}"  @click="gteChart1Data(1)">
                    <span>周</span>
                </div>
                <div class="item-btn" :class="{'active': chart1 === 2}"  @click="gteChart1Data(2)">
                    <span>月</span>
                </div>
                <div class="item-btn" :class="{'active': chart1 === 3}"  @click="gteChart1Data(3)">
                    <span>年</span>
                </div>
            </div>
            <div class="my-charts" ref="charts1"></div>
        </div>

        <!--统计图表2-->
        <div class="diagram-LR">
            <div class="diagram-item">
                <div class="time-button">
                    <div class="item-btn" :class="{'active': chart2 === 1}" @click="gteChart2Data(1)">
                        <span>周</span>
                    </div>
                    <div class="item-btn" :class="{'active': chart2 === 2}" @click="gteChart2Data(2)">
                        <span>月</span>
                    </div>
                    <div class="item-btn" :class="{'active': chart2 === 3}" @click="gteChart2Data(3)">
                        <span>年</span>
                    </div>
                </div>
                <div class="my-charts" ref="charts2"></div>
            </div>

            <div class="diagram-item">
                <div class="time-button">
                    <div class="item-btn" :class="{'active': chart3 === 1}"  @click="gteChart3Data(1)">
                        <span>周</span>
                    </div>
                    <div class="item-btn" :class="{'active': chart3 === 2}"  @click="gteChart3Data(2)">
                        <span>月</span>
                    </div>
                    <div class="item-btn" :class="{'active': chart3 === 3}"  @click="gteChart3Data(3)">
                        <span>年</span>
                    </div>
                </div>
                <div class="my-charts" ref="charts3"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { get } from '@/utils/request';

export default {
    data(){
        return {
            data:{
                todaySales: 0, // 今日销售额
                lastdaySales: 0, // 昨日销售额
                currentMonthSales: 0, // 本月销售额
                todaySalesNumber: 0, // 今日销售数量
                lastdaySalesNumber: 0, // 昨日销售数量
                currentMonthSalesNumber: 0, // 本月销售数量
                todayUserAdd: 0, // 今日用户新增
                lastdayUserAdd: 0, // 昨日用户新增
                currentMonthUserAdd: 0, // 本月用户新增
                todayValidUserAdd: 0, // 今日有效用户新增
                lastdayValidUserAdd: 0, // 昨日有效用户新增
                currentMonthValidUserAdd: 0, // 本月有效用户新增
                todayVisitNumber: 0, // 今日访问数量
                lastdayVisitNumber: 0, // 昨日访问数量
                currentMonthVisitNumber: 0, // 本月访问数量
                todayVisitorNumber: 0, // 今日访客数量
                lastdayVisitorNumber: 0, // 昨日访客数量
                currentMonthVisitorNumber: 0, // 本月访客数量
            },
            chart1: 1,
            chart2: 1,
            chart3: 1,
        }
    },
    created() {
        this.getIndexReportNumber();
        setTimeout(()=>{
            this.gteChart1Data()
            this.gteChart2Data()
            this.gteChart3Data()
        },1000)
    },
    methods:{
        // 跳转
        onSkip(url){
            this.$router.push(url);
        },

        // 获取销售信息
        gteChart1Data(timeType = 1){
            get('/report/reportdaily/findListByType',{
                dataTypes: '5,6',
                timeType,
            }).then((res)=>{
                if(res.success && res.code == 200){
                    this.chart1 = timeType
                    this.initChart1(res.list)
                }
            })
        },

        initChart1(list){
            let charts1 = echarts.init(this.$refs.charts1);
            charts1.setOption({
                color: [ '#ff7070', '#5470c6'],
                title: {
                    text: '销售数据'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['销售数量', '销售金额']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: list[0].map((item) => item.timeX)
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '销售数量',
                        type: 'line',
                        data: list[0].map((item) => item.valueY)
                    },
                    {
                        name: '销售金额',
                        type: 'line',
                        data: list[1].map((item) => item.valueY)
                    }
                ]
            })
        },

        // 获取用户信息
        gteChart2Data(timeType = 1){
            get('/report/reportdaily/findListByType',{
                dataTypes: '3,4',
                timeType,
            }).then((res)=>{
                if(res.success && res.code == 200){
                    this.chart2 = timeType
                    this.initChart2(res.list)
                }
            })
        },

        initChart2(list){
            let charts2 = echarts.init(this.$refs.charts2);
            charts2.setOption({
                color: [ '#37A2FF', '#FF0087'],
                title: {
                    text: '用户数据'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['用户新增', '有效用户新增']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: list[0].map((item) => item.timeX)
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '用户新增',
                        type: 'line',
                        data: list[0].map((item) => item.valueY)
                    },
                    {
                        name: '有效用户新增',
                        type: 'line',
                        data: list[1].map((item) => item.valueY)
                    }
                ]
            })
        },

        // 获取访客信息
        gteChart3Data(timeType = 1){
            get('/report/reportdaily/findListByType',{
                dataTypes: '2,1',
                timeType,
            }).then((res)=>{
                if(res.success && res.code == 200){
                    this.chart3 = timeType
                    this.initChart3(res.list)
                }
            })
        },

        initChart3(list){
            let charts3 = echarts.init(this.$refs.charts3);
            charts3.setOption({
                color: ['#FFBF00', '#00DDFF'],
                title: {
                    text: '访客数据'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['访问数量', '访客数量']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: list[0].map((item) => item.timeX)
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '访问数量',
                        type: 'line',
                        data: list[0].map((item) => item.valueY)
                    },
                    {
                        name: '访客数量',
                        type: 'line',
                        data: list[1].map((item) => item.valueY)
                    }
                ]
            })
        },

        // 获取本月和上月数据
        getIndexReportNumber(){
            get('/report/utils/getIndexNumber').then((res)=>{
                if(res.success){
                    this.data = res.data;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>

.pages{
    width: 100%;
    padding: 10px;
    background-color: #f0f2f5;

    //顶部统计
    .statistics-number{
        width: 100%;
        display: flex;

        :not(:first-child){
            margin-left: 10px;
        }

        .statistics-item{
            flex: 1;
            height: 192px;
            min-width: 215px;
            padding: 0px 15px;
            background-color: #fff;

            .title{
                width: 100%;
                height: 50px;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .tag{
                    padding: 0 5px;
                    font-size: 12px;
                    color: #409EFF;
                    border: 1px solid #409EFF;
                    border-radius: 5px;
                }
            }

            .number{
                width: 100%;
                height: 40px;
                margin-bottom: 10px;
                font-size: 32px;
                display: flex;
                align-items: center;
            }

            .details{
                width: 100%;
                height: 42px;
                font-size: 14px;
                color: #606266;
                border-bottom: 1px solid #e5eeff;
            }

            .total{
                width: 100%;
                height: 50px;
                font-size: 12px;
                color: #999999;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }
    }

    //快捷菜单
    .shortcut-menu{
        width: 100%;
        height: 150px;
        margin-top: 10px;
        display: flex;
        align-items: center;

        :not(:first-child){
            margin-left: 10px;
        }

        .menu-item{
            flex: 1;
            height: 100%;
            cursor: pointer;
            background-color: #fff;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            span{
                margin-left: 0;
            }

            .icon-box{
                width: 48px;
                height: 48px;
                margin-bottom: 10px;
                background-color: #eeeeee;
                border-radius: 50%;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;

                .iconfont{
                    font-size: 24px;
                }
            }
        }
    }

    //统计图表
    .diagram{
        position: relative;
        width: 100%;
        height: 372px;
        padding: 10px;
        margin-top: 10px;
        background-color: #fff;

    }

    //统计图表2
    .diagram-LR{
        width: 100%;
        height: 372px;
        margin-top: 10px;
        display: flex;

        :not(:first-child){
            margin-left: 10px;
        }

        .diagram-item{
            position: relative;
            flex: 1;
            height: 100%;
            padding: 10px;
            background-color: #FFF;
        }
    }

    .my-charts{
        width: 100%;
        height: 100%;
    }

    .time-button{
        position: absolute;
        top: 10px;
        right: 10px;
        width: 150px;
        height: 30px;
        cursor: pointer;
        border-radius: 5px;
        border: 1px solid #dcdfe6;
        font-size: 12px;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .item-btn{
            flex: 1;
            height: 100%;
            margin-left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .active{
            background-color: #409EFF;
            color: #fff;
        }

        :not(:first-child){
            border-left: 1px solid #dcdfe6;
        }
    }
}

@media screen and (max-width: 1199px) {

    //顶部统计
    .statistics-number{
        flex-direction: column;

        :not(:first-child){
            margin-top: 10px;
        }

        :not(:first-child){
            margin-left: 0px !important;
        }
    }

    //快捷菜单

    //统计图表
    .diagram-LR{
        display: block;
    }
}

</style>
